export class AuthRequestError extends Error {
  constructor(message, status) { super(message); this.status = status; }
}
/** Stateless H5/Expo transport; never persists OTPs. */
export function createPhoneAuthClient(baseURL) {
  const request = async (path, body, token) => {
    const controller = new AbortController();
    const timeout = setTimeout(() => controller.abort(), 15000);
    try {
      const response = await fetch(`${baseURL.replace(/\/$/u, "")}/phone-auth/${path}`, {
        method: body === undefined ? "GET" : "POST",
        headers: { "Content-Type": "application/json", ...(token ? { Authorization: `Bearer ${token}` } : {}) },
        ...(body === undefined ? {} : { body: JSON.stringify(body) }),
        signal: controller.signal,
      });
      const result = await response.json();
      if (!response.ok || !result.success) throw new AuthRequestError(typeof result.message === "string" ? result.message : "请求失败，请重试", response.status);
      return result.data;
    } catch (error) {
      if (error instanceof AuthRequestError) throw error;
      throw new AuthRequestError("网络连接失败，请检查网络后重试", 0);
    } finally { clearTimeout(timeout); }
  };
  return {
    sendCode: phoneNumber => request("send-code", { phoneNumber }),
    verify: async (phoneNumber, code) => {
      const result = await request("verify", { phoneNumber, code });
      return { ...result.user, token: result.token };
    },
    session: async token => {
      const result = await request("session", undefined, token);
      return { ...result.user, token };
    },
    logout: token => request("logout", {}, token),
  };
}
